import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const TooltipTitle = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.fixed.grey['800'],
  borderRadius: '0.75rem',
  boxShadow: theme.shadows[5],
  marginTop: '0.25rem !important',
  padding: '1rem',
}));
